<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 unnumbered" id="الخاتم-العجيب">
<img alt="" src="media/image1.jpg" style="width:8.11in;height:8.23in"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?428d663e